import { css } from 'styled-components';

import checked from '~/components/svg-icon/images/ic-24-checkbox-checked.svg';
import off from '~/components/svg-icon/images/ic-24-checkbox-enabled.svg';
import disabled from '~/components/svg-icon/images/ic-24-checkbox-enabled.svg';

export default css`
  width: 24px;
  height: 24px;
  margin: 0;
  border: 0;
  border-radius: 0;
  background: url(${off}) center center no-repeat;
  background-size: cover;
  appearance: none;
  cursor: pointer;

  &:checked {
    background-image: url(${checked});
  }

  &:disabled {
    background-image: url(${disabled});
  }
`;
